/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProblemDetails, WorkInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class BackgroundWellsDataImportClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Вернёт информацию по задаче по ее идентификатору
   * @request GET:/geoimport/works/{workId}/get_info
   * @secure
   */
  backgroundWellsDataImportGetWorkInfo = (workId: string, params: RequestParams = {}) =>
    this.http.request<WorkInfo, ProblemDetails>({
      path: `/geoimport/works/${workId}/get_info`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Вернёт информацию по выполняющимся задачам
   * @request GET:/geoimport/works/get_active_infos
   * @secure
   */
  backgroundWellsDataImportGetActiveWorkInfos = (params: RequestParams = {}) =>
    this.http.request<WorkInfo[], any>({
      path: `/geoimport/works/get_active_infos`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Остановит фоновую задачу
   * @request POST:/geoimport/works/{workId}/stop
   * @secure
   */
  backgroundWellsDataImportStopWork = (workId: string, params: RequestParams = {}) =>
    this.http.request<void, ProblemDetails>({
      path: `/geoimport/works/${workId}/stop`,
      method: 'POST',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Начинает фоновый импорт из ГеоБД всех скважинных данных для заданного месторождения.
   * @request POST:/geoimport/works/for_field/{fieldUid}/all_data/start
   * @secure
   */
  backgroundWellsDataImportStartImportAllWellsDataForField = (
    fieldUid: string,
    query?: {
      /**
       * После импорта добавить скважины в проект
       * @format uuid
       */
      projectId?: string
      /**
       * Заново загрузить из ГеоБд уже загруженные данные скважин
       * @default false
       */
      forceReimport?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, string | ProblemDetails>({
      path: `/geoimport/works/for_field/${fieldUid}/all_data/start`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Начинает фоновый импорт из ГеоБД всех скважинных данных по списку идентификаторов скважин.
   * @request POST:/geoimport/works/all_data/start
   * @secure
   */
  backgroundWellsDataImportStartImportAllWellsData = (
    data: string[],
    query?: {
      /**
       * После импорта добавить скважины в проект
       * @format uuid
       */
      projectId?: string
      /**
       * Заново загрузить из ГеоБд уже загруженные данные скважин
       * @default false
       */
      forceReimport?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, string | ProblemDetails>({
      path: `/geoimport/works/all_data/start`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags BackgroundWellsDataImport
   * @summary Начинает фоновый импорт из ГеоБД устьевых координат скважин по списку идентификаторов скважин.
   * @request POST:/geoimport/works/wellheads/start
   * @secure
   */
  backgroundWellsDataImportStartImportWellheads = (
    data: string[],
    query?: {
      /**
       * Заново загрузить из ГеоБд уже загруженные данные скважин
       * @default false
       */
      forceReimport?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, string | ProblemDetails>({
      path: `/geoimport/works/wellheads/start`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
